import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output
} from '@angular/core';

import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PortalConfig, PortalCredential, PortalType } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';

import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'app-portal-credential',
  templateUrl: './portal-credential.component.html',
  styleUrls: ['./portal-credential.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ImmomioTooltipDirective,
    TranslatePipe,
    ImmomioButtonComponent
  ]
})
export class PortalCredentialComponent implements OnInit {
  readonly credential = input<PortalCredential>(undefined);
  readonly config = input<PortalConfig>(undefined);
  readonly selected = input(false);

  // behaviour control inputs
  readonly disabled = input(false);
  readonly selectable = input(true);
  readonly removable = input(false);
  // temporary
  readonly deselectable = input(true);

  readonly togglePortal = output<PortalCredential>();
  readonly remove = output<PortalCredential>();

  public checkControl = new FormControl({
    value: this.selected(),
    disabled: this.isDisabled
  });

  public get isImmoscout() {
    return this.credential()?.portal === PortalType.IMMOBILIENSCOUT24_DE;
  }

  public ngOnInit() {
    this.checkControl.patchValue(this.selected());

    this.checkControl.valueChanges.subscribe(() =>
      this.togglePortal.emit(this.credential())
    );
  }

  public onRemove() {
    this.remove.emit(this.credential());
  }

  public get isDisabled() {
    return (
      this.disabled() ||
      !this.selectable() ||
      (this.selected() && !this.deselectable())
    );
  }
}
